<template>
  <h1 class="specialcar-header">
    <small>{{car.maker}}</small>&nbsp;
    <span class="mr-3">{{car.name}}</span>
    <v-chip color="green" class="white--text">{{car.type | typename}}</v-chip>
  </h1>
</template>

<style lang="scss">
@import '@/libs/vuetify/styles/variables.scss';

.specialcar-header {
  margin-bottom: 1.5rem;

  @extend %typo-headline;

  .v-chip.v-size--default {
    padding-left: 1rem;
    padding-right: 1rem;
    height: 1.5rem;
    position: relative;
    top: -0.125rem;
  }
}
</style>

<script>
import * as C from '@/app/special/consts'

export default {
  name: 'CarHeader',
  props: {
    car: {
      type: Object,
      required: true
    }
  },
  filters: {
    typename (type) {
      return C.cartypeNames[type] || ''
    }
  }
}
</script>
